import { makeTokenizedRequest } from '../../utils/request-utils';
import { START_PREFETCH_CONTENT_TYPE } from './device-manager-constants';
export function consolidatedStreamStartPrefetchRequest(endpoint, ottHeaders, userToken, timeouts, path, prePlayoutId, metadataToken, streamSourceType, _a, logger) {
    var contentId = _a.contentId, providerVariantId = _a.providerVariantId, serviceKey = _a.serviceKey, eventId = _a.eventId;
    var requestParams = makeTokenizedRequest(START_PREFETCH_CONTENT_TYPE, 'POST', ottHeaders, userToken, timeouts, {
        session: {
            prePlayoutId: prePlayoutId,
            metadataToken: metadataToken,
        },
        content: {
            id: contentId,
            eventId: eventId,
            providerVariantId: providerVariantId,
            serviceKey: serviceKey,
            streamSourceType: streamSourceType,
        },
    }, logger);
    requestParams.statusCodeCheck = false;
    return ["".concat(endpoint, "/concurrency/streaming/preauthorised"), requestParams];
}
//# sourceMappingURL=device-manager-request.js.map